import { Dropdown, useInputHelper, DefaultDropdownProps } from 'framework/form';
import { CLOSED_REASON } from 'domain/sales/opportunity/opportunityService';

interface Props extends DefaultDropdownProps {
  type: 'PRIMARY' | 'SECONDARY';
  stageSource: string;
}

const ClosedReasonDropdown = ({ type, stageSource, ...props }: Props) => {
  const { getValue: getStage } = useInputHelper({ source: stageSource });
  const stage = getStage() as any as 'CLOSED_WON' | 'CLOSED_LOST';
  const options = CLOSED_REASON[type][stage];

  return (
    <Dropdown
      placeholder="Choose Closed Reason"
      options={Object.entries(options).map(entry => {
        const [value, label] = entry;

        return {
          value,
          label,
        };
      })}
      label="Closed reason"
      {...props}
    />
  );
};

export default ClosedReasonDropdown;
